import React from 'react';
import { Button, Icon } from 'semantic-ui-react';

export const StyleButton = ({ active, iconName, onToggle, style }) => {
  const handleToggle = e => {
    e.preventDefault();
    onToggle(style);
  };

  return (
    <span onMouseDown={handleToggle}>
      <Button icon={Boolean(iconName)} active={active} size="mini">
        {iconName && <Icon name={iconName} />}
      </Button>
    </span>
  );
};



// WEBPACK FOOTER //
// ./src/component/TextEditor/StyleButton.js